import { AccessTimeFilled, Cancel, CheckCircle, CheckCircleOutline } from "@mui/icons-material";
import { styled } from "@mui/material/styles";

export const BadgeStyledDiv = styled("div")(({ theme }) => ({
    background: theme.palette.text.contrastText,
    width: theme.spacing(2),
    height: theme.spacing(2),
    borderRadius: "50%",
}));
const ConfirmedBadge = (props) => (<CheckCircle sx={{ color: "success.dark" }} {...props} />);
const RegisteredBadge = (props) => (<CheckCircleOutline sx={{ color: "success.dark" }} {...props} />);
const WaitlistedBadge = (props) => (<AccessTimeFilled sx={{ color: "info.main" }} {...props} />);
const DeniedBadge = (props) => (<Cancel {...props} />);
const badgeComponentMap = {
    "confirmed": ConfirmedBadge,
    "registered": RegisteredBadge,
    "waitlisted": WaitlistedBadge,
    "denied": DeniedBadge,
};

export const EntryStatusBadge = ({ entryStatus }) => {
    const BadgeComponent = badgeComponentMap[entryStatus];

    return (
        <BadgeStyledDiv>
            <BadgeComponent fontSize="small" titleAccess={entryStatus} />
        </BadgeStyledDiv>
    );
};
